import { RootState } from 'store';
import OrdersSearchState, { OrdersSearchStateKeys } from './types';

export const selectOrderSearchState = (state: RootState) =>
  state.orders.search as OrdersSearchState;

export const selectOrderSearchByKey =
  (orderSearchKey: OrdersSearchStateKeys) => (state: RootState) =>
    state.orders.search[orderSearchKey];
